const timeoutDictionary = {};

export function DelayExecute(action: ()=>void, key: string, timeout: number = 1500 ) {
	if (!action || !key) return;

	if (timeoutDictionary[key]){
		clearTimeout(timeoutDictionary[key]);
	}

	timeoutDictionary[key] = setTimeout(() => {
		action();
	}, timeout);	
}
